import { Button, Card, CardHeader, Stack, TextField } from '@mui/material';
import { Formik } from 'formik';
import { auth, googleProvider } from '../../firebase';
import { useNavigate } from 'react-router';
import {
  useSignInWithPopup,
  useSignInWithEmailAndPassword,
} from '../../api/hooks/auth';

const Login = () => {
  const navigate = useNavigate();

  const { mutate: login } = useSignInWithEmailAndPassword(auth, {
    onSuccess() {
      navigate('/products');
    },
    onError() {
      console.error('Could not sign you in!');
    },
  });

  const handleLoginWithPassword = (values: {
    email: string;
    password: string;
  }) => login(values);

  const { mutate: signInWithPopUp } = useSignInWithPopup(auth, {
    onSuccess() {
      navigate('/products');
    },
    onError() {
      console.error('Could not sign you in!');
    },
  });

  const signInWithGoogle = () => signInWithPopUp({ provider: googleProvider });

  return (
    <Card elevation={7} sx={{ mx: 'auto', mt: 10, p: 5, width: 400 }}>
      <CardHeader title="Login" />
      <Stack>
        <Formik
          initialValues={{
            email: '',
            password: '',
          }}
          onSubmit={handleLoginWithPassword}
        >
          {({ submitForm, getFieldProps }) => (
            <Stack component="form" alignItems="center" width="100%">
              <TextField
                type="email"
                label="Email"
                {...getFieldProps('email')}
                sx={{ m: 1, width: '100%' }}
              />
              <TextField
                type="password"
                label="Password"
                {...getFieldProps('password')}
                sx={{ m: 1, width: '100%' }}
              />
              <Button variant="flat" fullWidth onClick={submitForm}>
                Login
              </Button>
            </Stack>
          )}
        </Formik>
        <Button
          variant="flat"
          color="error"
          onClick={signInWithGoogle}
          sx={{ mt: 1 }}
        >
          Sign in with Google
        </Button>
        <Button
          variant="flat"
          onClick={() => navigate('/signup')}
          sx={{ mt: 1 }}
        >
          Don't have an account? Signup
        </Button>
      </Stack>
    </Card>
  );
};

export default Login;
